import React from "react";
import { Skeleton } from "../../ui/skeleton";

export default function PlanLoader() {
  return (
    <div className="leading-5 border-border border bg-background py-4 px-6 rounded-xl">
      <Skeleton className="h-6 w-6/12 mb-2" />
      <Skeleton className="h-2 w-8/12" />
      <div className="flex justify-center my-7">
        <Skeleton className="h-12 w-full" />
        <div className="ml-3">
          <Skeleton className="h-6 w-4/12" />
          <Skeleton className="h-6 w-4/12" />
        </div>
      </div>
      <Skeleton className="h-10 w-full" />
      <Skeleton className="h-10 w-full my-6" />

      <div className="space-y-3 pb-4 border-b">
        <div className="flex items-center">
          <Skeleton className="h-5 w-6/12" />
        </div>
        <div className="flex items-center">
          <Skeleton className="h-5 w-6/12" />
        </div>
        <div className="flex items-center">
          <Skeleton className="h-5 w-6/12" />
        </div>
      </div>
      <div className="space-y-3 pb-4 border-b mt-3">
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-full" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-full" />
        </div>
        <div className="flex items-center justify-between">
          <Skeleton className="h-5 w-full" />
        </div>
      </div>
      <div className="space-y-3 mt-4">
        {[1, 2, 3, 4, 5, 6].map((feature) => (
          <div className="flex items-center">
            <Skeleton className="h-5 w-full" />
          </div>
        ))}
      </div>
    </div>
  );
}
